import { useAsync } from 'react-use';
import { OffersApi } from '@model/iceberg/service';
import { GenericComponent } from '@model/content';
import { Component as ComponentContainer } from '@styles/layout';
import { OffersGroup } from '@components/common/offers';

export const SpecialOffersContainer = ({ path, data }: GenericComponent) => {
  if (!path) {
    return null;
  }
  const { value: offers } = useAsync(async () => {
    return data ? data : await new OffersApi().getOffersByDestination(path);
  }, [path]);

  return offers?.data ? (
    <ComponentContainer>
      <OffersGroup offerTypesResponse={offers} />
    </ComponentContainer>
  ) : null;
};
